<template>
  <div class="timer-page">
    <clock class="large"></clock>

    <hint-page v-if="showHint" @close="showHint = false">
      <i>Headphones are advised for this experience.</i>
      <br />
      <br />
      <i>You should now be hearing background audio.</i>
    </hint-page>

    <div class="page-title" id="typewriter"></div>
  </div>
</template>

<script>
import Typewriter from "typewriter-effect/dist/core";
import Clock from "../components/Clock.vue";
import HintPage from "./HintPage.vue";

export default {
  name: "timer-page",
  props: {
    time: Number,
  },
  components: {
    Clock,
    HintPage,
  },
  data: function () {
    return {
      showHint: true,
    };
  },
  mounted() {
    var el = document.getElementById("typewriter");

    var typewriter = new Typewriter(el, {
      loop: true,
      cursor: "",
    });

    typewriter
      .typeString(
        "<b>[</b> <i>EMPATHY</i> <b>]</b> <i>Consider less explored perspectives.</i>"
      )
      .pauseFor(6000)
      .deleteAll()
      .typeString(
        "<b>[</b> <i>FORESIGHT</i> <b>]</b> <i>Create the future at all costs.</i>"
      )
      .pauseFor(6000)
      .deleteAll()
      .typeString(
        "<b>[</b> <i>INSIGHT</i> <b>]</b> <i>Your personal experience/s are valuable.</i>"
      )
      .pauseFor(6000)
      .deleteAll()
      .typeString(
        "<b>[</b> <i>DISCLAIMER</i> <b>]</b> <i>Leave your morals at the door.</i"
      )
      .deleteAll()
      .start();
  },
};
</script>

<style lang="less">
.timer-page {
  width: 768px;
  height: 768px;
  background-image: url("../assets/images/page-timer.png");

  .clock {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .page-title {
    position: absolute;
    bottom: 0px;
    left: 90px;
    font-size: 13px;
    height: 13px;
  }

  .vue-typer .custom.caret {
    display: none;
  }
}
</style>
